import { number, string, arrayOf, instanceOf, exact } from 'prop-types';

export const singleCheck = exact({
  id: string,
  imageMd5: string,
  missionId: string,
  imageId: string,
  indexName: string,
  missionEntities: instanceOf(Object),
  tagId: string,
  coords: arrayOf(number),
  labeling: instanceOf(Object),
  check: instanceOf(Object),
});

export const checks = arrayOf(singleCheck);

export default {
  singleCheck,
  checks,
};
